import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Siren, Envelope, MapPinLine, Warning, Timer } from "@phosphor-icons/react";

/** Emergency job detail: how this job came in from the inbox — SLA read from the email, unconfirmed address, AI's view. */
export default function EmailEmergencyBanner({ job, onEditAddress, className = "" }) {
  if (!job || job.source !== "email") return null;
  const sla = job.sla_source || {};
  const routine = job.emergency_ai?.genuine_emergency === false;
  const slaNote = sla.source === "email" ? `SLA shortened to ${sla.hours}h — the email asked for “${sla.phrase}”`
    : sla.source === "asap" ? `SLA shortened to ${sla.hours}h — the email said “${sla.phrase}”`
      : sla.source === "ai" ? `SLA ${sla.hours}h — response time read from the email`
        : sla.source === "staff" ? `SLA ${sla.hours}h set by staff` : `Standard ${sla.hours || job.response_hours || 4}h emergency SLA`;
  return (
    <div className={`space-y-2 ${className}`} data-testid="emg-email-banner">
      <div className="rounded-md border border-red-200 dark:border-red-900 bg-red-50/70 dark:bg-red-950/20 px-4 py-2.5 flex items-start gap-3 text-xs">
        <Siren size={16} weight="fill" className="text-red-600 shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-red-800 dark:text-red-300">Raised from an email{job.source_email_from ? ` from ${job.source_email_from}` : ""}</p>
          <p className="text-red-700/90 dark:text-red-300/80 mt-0.5 flex items-center gap-1" data-testid="emg-email-sla-note"><Timer size={12} /> {slaNote}</p>
        </div>
        {job.source_email_id && (
          <Link to={`/inbox?item=${job.source_email_id}`} className="inline-flex items-center gap-1 text-red-700 dark:text-red-300 hover:underline shrink-0" data-testid="emg-open-source-email"><Envelope size={12} /> Open email</Link>
        )}
      </div>
      {job.address_unconfirmed && (
        <div className="rounded-md border-2 border-red-500 bg-red-100/80 dark:bg-red-950/40 px-4 py-2.5 flex items-center gap-3 text-xs" data-testid="emg-address-unconfirmed">
          <MapPinLine size={16} weight="fill" className="text-red-700 shrink-0" />
          <p className="flex-1 font-semibold text-red-800 dark:text-red-200">Site address missing — the email didn't give one and the client has no matching property. The sender has been asked to reply with it; the SLA clock is already running.</p>
          {onEditAddress && <Button size="sm" className="bg-red-600 hover:bg-red-700 text-white shrink-0" onClick={onEditAddress} data-testid="emg-set-address-btn">Set address</Button>}
        </div>
      )}
      {routine && (
        <div className="rounded-md border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30 px-4 py-2 flex items-start gap-2 text-xs text-amber-800 dark:text-amber-300" data-testid="emg-ai-routine-flag">
          <Warning size={14} weight="fill" className="shrink-0 mt-0.5" />
          <span><strong>AI double-check:</strong> this may be a routine mention of “emergency”{job.emergency_ai.reason ? ` — ${job.emergency_ai.reason}` : ""}. It was raised anyway so nothing is missed; downgrade or cancel it if it's not a real emergency.</span>
        </div>
      )}
    </div>
  );
}
